import React from 'react';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import {
    RadioButton,
    RadioButtonGroup,
} from 'material-ui/RadioButton';
import NumberFormat from 'react-number-format';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import {
    GridList,
    GridTile,
} from 'material-ui/GridList';
import {
    Grid,
    Icon,
} from '../../components';
import {
    projetoService,
    eventoService,
    subeventoService,
    areaService,
    Utils,
    tipoSubmissaoService,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class Projetos extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ano: '',
            eventoSelecionado: -1,
            dsEventos: [],
            dsAreas: [],
            dsSubeventos: [],
            subeventoSelecionado: 0,
            areaSelecionada: 0,
            dsTipos: [],
            tipoSubmissaoSelecionado: 0,
            dsProjetos: [],
            pago: 2,
        };
    }

    async componentWillMount() {
        const ano = new Date().getFullYear();

        const eventos = await eventoService.getEventosPeloAno(ano);
        this.setState({
            ano,
            dsEventos: eventos,
        });
    }

    async getProjetos(subevento, evento, area, pago, tipoSubmissao) {
        try {
            const projetos = await projetoService.getProjetos(subevento, evento, area, pago, tipoSubmissao);
            this.setState({ dsProjetos: projetos });
        } catch (error) {
            Utils.showToast(error.message);
        }
    }

    async buscarEventosPeloAno() {
        let eventos = [];
        if (this.state.ano) {
            eventos = await eventoService.getEventosPeloAno(this.state.ano);
        }
        this.setState({
            dsEventos: eventos,
            eventoSelecionado: 0,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
            tipoSubmissaoSelecionado: 0,
        });
    }

    async buscarSubeventosPeloEvento(eventoCodigo) {
        this.setState({
            eventoSelecionado: eventoCodigo,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
            tipoSubmissaoSelecionado: 0,
        });
        const { pago } = this.state;

        const subeventos = await subeventoService.getSubeventosDoEvento(eventoCodigo);
        this.setState({ dsSubeventos: subeventos });
        this.getProjetos(0, eventoCodigo, 0, pago, 0);
    }

    async buscarAreasPeloSubevento(subeventoCodigo) {
        this.setState({ subeventoSelecionado: subeventoCodigo, areaSelecionada: 0, tipoSubmissaoSelecionado: 0 });
        const {
            eventoSelecionado,
            pago,
        } = this.state;

        const areas = await areaService.getAreasCoordenador(subeventoCodigo);
        const tiposSubmissao = await tipoSubmissaoService.getTiposSubmissao(subeventoCodigo);
        this.setState({ dsAreas: areas, dsTipos: tiposSubmissao });
        this.getProjetos(subeventoCodigo, eventoSelecionado, 0, pago, 0);
    }

    async buscarAreas(area) {
        const {
            subeventoSelecionado,
            eventoSelecionado,
            pago,
            tipoSubmissaoSelecionado,
        } = this.state;
        this.setState({ areaSelecionada: area });
        this.getProjetos(subeventoSelecionado, eventoSelecionado, area, pago, tipoSubmissaoSelecionado);
    }

    async buscarTipoSubmissao(tipoSubmissao) {
        const {
            subeventoSelecionado,
            eventoSelecionado,
            areaSelecionada,
            pago,
        } = this.state;
        this.setState({ tipoSubmissaoSelecionado: tipoSubmissao });
        this.getProjetos(subeventoSelecionado, eventoSelecionado, areaSelecionada, pago, tipoSubmissao);
    }

    async bascarEventoPorPago(pago) {
        const {
            subeventoSelecionado,
            eventoSelecionado,
            areaSelecionada,
            tipoSubmissaoSelecionado,
        } = this.state;

        this.setState({ pago });
        this.getProjetos(subeventoSelecionado, eventoSelecionado, areaSelecionada, pago, tipoSubmissaoSelecionado);
    }

    render() {
        const {
            ano,
            eventoSelecionado,
            subeventoSelecionado,
            dsEventos,
            dsSubeventos,
            dsAreas,
            areaSelecionada,
            pago,
            dsProjetos,
            dsTipos,
            tipoSubmissaoSelecionado,
        } = this.state;

        return (
            <PrincipalMaster title="Resumos/Projetos Submetidos" {...this.props}>
                <div className="padding-content">
                    <GridList cols={2} cellHeight="auto">
                        <GridTile cols={2}>
                            <NumberFormat
                                format="####"
                                customInput={TextField}
                                required
                                value={ano}
                                errorText={ano ? '' : 'Campo obrigatório'}
                                floatingLabelText="Ano"
                                onBlur={() => this.buscarEventosPeloAno()}
                                onChange={e => this.setState({ ano: e.target.value })}
                            />
                        </GridTile>
                        <GridTile cols={2}>
                            <SelectField
                                floatingLabelText="Selecione um evento"
                                value={eventoSelecionado}
                                onChange={(_event, _index, value) => this.buscarSubeventosPeloEvento(value)}
                                errorText={eventoSelecionado > 0 ? '' : 'Campo obrigatório'}
                                fullWidth
                            >
                                {
                                    dsEventos.map(evento => (
                                        <MenuItem key={evento.CODIGO} value={evento.CODIGO} primaryText={evento.NOME} />
                                    ))
                                }
                            </SelectField>
                        </GridTile>
                        <GridTile cols={2}>
                            <SelectField
                                floatingLabelText="Selecione um subevento"
                                value={subeventoSelecionado}
                                onChange={(_event, _index, value) => this.buscarAreasPeloSubevento(value)}
                                fullWidth
                            >
                                <MenuItem value={0} primaryText="Todos" />
                                {
                                    dsSubeventos.map(subevento => (
                                        <MenuItem key={subevento.CODIGO} value={subevento.CODIGO} primaryText={subevento.NOME} />
                                    ))
                                }
                            </SelectField>
                        </GridTile>
                        <GridTile cols={2}>
                            <SelectField
                                floatingLabelText="Selecione uma área"
                                value={areaSelecionada}
                                onChange={(_event, _index, value) => this.buscarAreas(value)}
                                fullWidth
                            >
                                <MenuItem value={0} primaryText="Todas" />
                                {
                                    dsAreas.map(area => (
                                        <MenuItem key={area.CODIGO} value={area.CODIGO} primaryText={area.NOME} />
                                    ))
                                }
                            </SelectField>
                        </GridTile>
                        <GridTile cols={1}>
                            <h4>Tipo de submissão</h4>
                            {
                                subeventoSelecionado > 0 ?
                                    <RadioButtonGroup
                                        name="tipoSubmissao"
                                        value={tipoSubmissaoSelecionado}
                                        defaultSelected={0}
                                        onChange={(_event, tipo) => this.buscarTipoSubmissao(tipo)}
                                    >
                                        <RadioButton value={0} label="Todos" />
                                        {
                                            dsTipos.map(x => <RadioButton key={x.CODIGO} value={x.CODIGO} label={x.DESCRICAO} />)
                                        }
                                    </RadioButtonGroup> :
                                    <p>Selecione o subevento para ver os tipos de submissão.</p>
                            }
                        </GridTile>
                        <GridTile cols={1}>
                            <h4>Pago?</h4>
                            <RadioButtonGroup
                                name="pago"
                                value={pago}
                                defaultSelected={2}
                                onChange={(_event, value) => this.bascarEventoPorPago(value)}
                            >
                                <RadioButton value={0} label="Não" />
                                <RadioButton value={1} label="Sim" />
                                <RadioButton value={2} label="Ambos" />
                            </RadioButtonGroup>
                        </GridTile>
                    </GridList>

                    <Grid
                        ref={(ref) => { this.projetosGridRef = ref; }}
                        stripedRows="true"
                        textTableEmpty="Nenhum projeto encontrado."
                        dataSource={dsProjetos}
                        columns={[

                            {
                                text: 'Nome', name: 'TITULO', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '350px',
                            },
                            {
                                text: 'Autor(es)', name: 'AUTOR(ES)', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Orientador(es)', name: 'ORIENTADOR(ES)', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Instituição', name: 'INSTITUICAO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Nº Avaliadores', name: 'NumAvaliadores', allowSort: true, allowSearch: false, searchOperator: 'LIKE', width: '100px',
                            },
                            {
                                text: 'Pago', name: row => (row.PAGO ? 'Sim' : 'Não'), allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '50px',
                            },
                            {
                                name: item => (
                                    <div>
                                        <a href={`/projeto-info/${item.CODIGO}`} target="_blank" rel="noopener noreferrer">
                                            <IconButton tooltip="Visualizar" >
                                                <Icon name="visibility" />
                                            </IconButton>
                                        </a>
                                        {
                                            !item.PAGO ?
                                                <a href={item.LINKBOLETO} target="_blank" rel="noopener noreferrer">
                                                    <IconButton tooltip="Gerar boleto">
                                                        <Icon name="payment" />
                                                    </IconButton>
                                                </a>
                                                : <span />
                                        }
                                    </div>
                                ),
                            },
                        ]}
                    />
                </div>
            </PrincipalMaster >
        );
    }
}

export default Projetos;
